import Axios from "axios";

export class PersonaNaturalService {

    getClientepn(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/persona-natural/lista?${queryParams}`).then(res => res.data);
    }

    newClientepn(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/persona-natural/nuevo`, data).then(res => res.data);
    }

    editarClientepn(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/persona-natural/editar`, data).then(res => res.data);
    }

    consultarClientepn(id, seccion) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/persona-natural/consulta/${id}/${seccion}`).then(res => res.data);
    }

    eliminarClientepn(id) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/persona-natural/eliminar/${id}`).then(res => res.data);
    }

    descargar(id) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/persona-natural/reporte/${id}`, {
            headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache', 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Expires': 0 },
            params: {
                t: new Date().getTime(),
            },
            responseType: 'blob'
        }).then(async res => res.data);
    }
}
